//@author: devin

import { S25ObjectDetailsService } from "../modules/object-details/s25.object.details.service";
import { AddRemoveUtil } from "../standalone/more-actions/edit/add.remove.util";
import { ModalCopyEditEventComponent } from "../standalone/more-actions/edit/modal.copy.edit.event.component";
import { MoreActionsService } from "../standalone/more-actions/more.actions.service";
import { jSith } from "../util/jquery-replacement";
import { S25Const } from "../util/s25-const";
import { S25Util } from "../util/s25-util";
import { S25Browser } from "../util/core/s25.browser";
import { S25Url } from "../util/core/s25.url";
import { S25Help } from "../modules/s25-help/s25.help.service";
import { S25Datefilter } from "../modules/s25-dateformat/s25.datefilter.service";
import { DataAccess } from "../dataaccess/data.access";
import { SettingsService } from "../services/settings.service";
import { UserprefService } from "../services/userpref.service";
import { UserprefDateBarrierService } from "../services/userpref.date.barrier.service";
import { UserprefStaticCachedService } from "../services/userpref.static.cached.service";
import { LynxService } from "../services/lynx.service";
import { FlsService } from "../services/fls.service";
import { AttachmentService } from "../services/attachment.service";
import { ConfigService } from "../services/config.service";
import { DatetimeService } from "../services/datetime.service";
import { PreferenceService } from "../services/preference.service";
import { ListStateService } from "../services/list.state.service";
import { ListGeneratorService } from "../services/list.generator.service";
import { ListService } from "../services/list.service";
import { AuditService } from "../services/audit.service";
import { CacheRepository } from "../decorators/cache.decorator";
import { ImageService } from "../services/image.service";
import { CustomAttributeService } from "../services/custom.attribute.service";
import { OlsService } from "../services/ols.service";
import { SequenceService } from "../services/sequence.service";
import { DocumentService } from "../services/document.service";
import { SortOrderService } from "../services/sort.order.service";
import { RoleService } from "../services/role.service";
import { OptService } from "../services/opt.service";
import { ResourceService } from "../services/resource.service";
import { FavoriteService } from "../services/favorite.service";
import { ViewerMessageService } from "../services/viewer.message.service";
import { TooltipService } from "../services/tooltip.service";
import { ContactService } from "../services/contact.service";
import { WelcomeMessageService } from "../services/welcome.message.service";
import { WelcomeMessageUtil } from "../services/welcome.message.util";
import { LangService } from "../services/lang.service";
import { InstCssService } from "../services/intscss.service";
import { LockService } from "../services/lock.service";
import { SpaceService } from "../services/space.service";
import { PendingObjectService } from "../services/pending.object.service";
import { EventService } from "../services/event.service";
import { EventEmailService } from "../services/event.email.service";
import { ResourceSpaceAvailService } from "../services/resource.space.avail.service";
import { ObjectSearchAvailabilityUtil } from "../util/object.search.availability.util";
import { OrganizationService } from "../services/organization.service";
import { PricingService } from "../services/pricing.service";
import { GroupService } from "../services/group.service";
import { NameService } from "../services/name.service";
import { ReservationService } from "../services/reservation.service";
import { BpeService } from "../modules/bpe/bpe.service";
import { TaskService } from "../services/task/task.service";
import { AdvancedSearchUtil } from "../modules/advanced-search/advanced-search-util";
import { LoginService } from "../services/login.service";
import { RegistrationService } from "../services/registration.service";
import { CalendarService } from "../modules/home/calendar/calendar.service";
import { TaskCalendarService } from "../services/task/task.calendar.service";
import { DashLangService } from "../modules/home/dash/service/dash.lang.service";
import { DashLangMap } from "../modules/home/dash/service/dash.lang.map";
import { AlertService } from "../services/alert.service";
import { BoundEventLocationUtil } from "../modules/s25-event/utils/bound.event.location.util";
import { MergeSearchService } from "../services/merge.search.service";
import { SearchCriteriaService } from "../services/search/search-criteria/search.criteria.service";
import { PublisherService } from "../services/publisher.service";
import { PasswordResetService } from "../services/password.reset.service";
import { LoginExemptRoute } from "../services/login.exempt.route";
import { ModalService } from "../modules/modal/modal.service";
import { RecommendedBrowsersModalComponent } from "../standalone/modals/recommended.browsers.modal.component";
import { ExpressSchedulingModal } from "../standalone/express-scheduling/express.scheduling.modal.component";
import { ServiceLoader } from "../services/service.loader";
import { PopoverService } from "../modules/s25-popover/popover.service";
import { FreshbooksService } from "../services/freshbooks.service";
import { EventStateChangeService } from "../services/event/event.state.change.service";
import { KeyboardSortableService } from "../services/keyboard.sortable.service";
import { EmbeddingUtil } from "../util/embedding.util";
import { OptUtil } from "../modules/s25-opt/s25.opt.util";
import { Api } from "../api/api";
import { AppPathsService } from "../services/app.paths.service";
import { SearchDropdownApi } from "../modules/s25-dropdown/single-select/s25.search.dropdown.component";
import { DropdownApi } from "../modules/s25-dropdown/dropdown.api";
import { SEARCH_MODEL_SKIP_LIST, SearchService } from "../services/search/search.service";
import { SearchCriteriaUtil } from "../services/search/search-criteria/search.criteria.util";
import { HierarchyApi } from "../modules/event-type-hierarchy/s25.event.type.hierarchy.component";
import { EventQuotaService } from "../services/event.quota.service";
import { EventFormConflictRepoService } from "../modules/s25-event-creation-form/occurrences/s25.event.form.conflict.repo.service";
import { EventFormOccurrenceUtil } from "../modules/s25-event-creation-form/occurrences/event.form.occurrence.util";
import { EventFormStore } from "../standalone/event-form/event.form.store";
import { ProfileUtil } from "../modules/s25-datepattern/profile.util";
import { S25ImageService } from "../modules/s25-image/s25.image.service";
import { EventDetailsListService } from "../services/event.details.list.service";
import { ItemColorMappingService } from "../services/item.color.mapping.service";
import { AvailService } from "../services/avail.service";
import { TaskEditService } from "../services/task/task.edit.service";
import { RuleTreeService } from "../services/rule.tree.service";
import { EventCreationFormService } from "../services/event.creation.form.service";
import { ReportService } from "../services/report.service";
import { Eval25Service } from "../services/eval25.service";
import { BoardService } from "../modules/s25-swarm-schedule/s25.board.service";
import { BOARD_CONST } from "../modules/s25-swarm-schedule/s25.board.const";
import { OccurrenceProfileUtil } from "../util/occurrence.profile.util";
import { OccurrenceValidationUtil } from "../util/occurrence.validation.util";
import { StandardScheduleService } from "../services/standard.schedule.service";
import { AriaLive } from "../services/aria.live.service";
import { EventSummaryService } from "../modules/s25-swarm-schedule/s25.event.summary.service";
import { TypeMapService } from "./type.map.service";
import { StripeService } from "../modules/s25-pricing/s25-payments/stripe.service";
import * as Sentry from "@sentry/angular";
import { TinymceLoader } from "../modules/tinymce/tinymce.loader";
import { PermissionService } from "../services/permission.service";
import { TaskTiersService } from "../services/task/task.tiers.service";
import { EventFormRuleUtil } from "../modules/s25-event-creation-form/s25.event.form.rule.util";
import { AuthService } from "../services/auth.service";
import { S25RuleTreeUtil } from "../modules/s25-rule-tree/s25.rule.tree.util";
import { TaskViewApi } from "../modules/s25-task-view/s25.task.view.component";
import { TaskNormalizeUtil } from "../services/task/task.normalize.util";
import { TelemetryService } from "../services/telemetry.service";
import { AiTelemetry } from "../services/ai.telemetry";
import { ModalMap } from "../modules/modal/modal.map";
import { EventFormDateOccurrencesModal } from "../modules/modal/modals/event.form.date.occurrences.modal.component";
import { EventFormDatePatternPickerModal } from "../modules/modal/modals/event.form.date.pattern.picker.modal.component";
import { EventFormObjectOccurrencesTableModal } from "../modules/modal/modals/event.form.object.occurrences.table.modal.component";
import { OccurrenceEditModal } from "../modules/modal/modals/occurrence.edit.modal.component";
import { RoseUtil } from "../standalone/more-actions/edit/rose.util.service";
import { DeviceService } from "../services/device.service";
import { CordovaService } from "../services/cordova.service";
import { PushNotifyService } from "../modules/bpe/push.notify.service";
import { StateService } from "../services/state.service";
import { S25States } from "../services/state/state.map";
import { NotificationService } from "../services/notification.service";
import { ScrollLockService } from "../services/scroll.lock.service";
import { SpreadSheetService } from "../modules/s25-spreadsheet/spreadsheet.service";
import { BudgetService } from "../modules/student-engagement/budget/budget.service";
import { StudentEngagementService } from "../modules/student-engagement/student.engagement.service";
import { SeAttendanceStore } from "../modules/student-engagement/attendance/se.attendance.store";
import { SEEventDetailsStore } from "../modules/student-engagement/event/se.event.details.store";
import { SeOrgSecurityStore } from "../modules/student-engagement/se.org.security.store";
import { SeOrgDetailsStore } from "../modules/student-engagement/organization/se.org.details.store";
import { SeEventCheckinStore } from "../modules/student-engagement/attendance/se.event.checkin.store";
import { TaskCompetingUtil } from "../modules/s25-task/task.competing.util";
import { NetworkHealthService } from "../services/network.health.service";
import { PricingStore } from "../modules/s25-pricing/reference-set-pricing/s25.event.pricing.store";

declare global {
    interface Window {
        angBridge: any;
    }
}

export class AngBridge {
    public static createAngBridge() {
        window.angBridge = window.angBridge || {};

        if (!window.angBridge.$injector) {
            let resolveInjector!: () => void;
            window.angBridge._injectorReady = new Promise<void>((resolve) => {
                resolveInjector = resolve;
            });
            window.angBridge._resolveInjector = resolveInjector;
        } else {
            window.angBridge._injectorReady = Promise.resolve();
        }

        window.angBridge.TypeMapService = TypeMapService;
        window.angBridge.CacheRepository = CacheRepository;
        window.angBridge.jSith = jSith;
        window.angBridge.S25Const = S25Const;
        window.angBridge.S25Util = S25Util;
        window.angBridge.S25Browser = S25Browser;
        window.angBridge.S25Url = S25Url;
        window.angBridge.S25Help = S25Help;
        window.angBridge.S25Datefilter = S25Datefilter;
        window.angBridge.DataAccess = DataAccess;
        window.angBridge.SettingsService = SettingsService;
        window.angBridge.UserprefService = UserprefService;
        window.angBridge.UserprefDateBarrierService = UserprefDateBarrierService;
        window.angBridge.UserprefStaticCachedService = UserprefStaticCachedService;
        window.angBridge.LynxService = LynxService;
        window.angBridge.FlsService = FlsService;
        window.angBridge.AttachmentService = AttachmentService;
        window.angBridge.ConfigService = ConfigService;
        window.angBridge.DatetimeService = DatetimeService;
        window.angBridge.PreferenceService = PreferenceService;
        window.angBridge.ListStateService = ListStateService;
        window.angBridge.ListGeneratorService = ListGeneratorService;
        window.angBridge.ListService = ListService;
        window.angBridge.AuditService = AuditService;
        window.angBridge.ImageService = ImageService;
        window.angBridge.CustomAttributeService = CustomAttributeService;
        window.angBridge.OlsService = OlsService;
        window.angBridge.SequenceService = SequenceService;
        window.angBridge.DocumentService = DocumentService;
        window.angBridge.SortOrderService = SortOrderService;
        window.angBridge.RoleService = RoleService;
        window.angBridge.OptService = OptService;
        window.angBridge.ResourceService = ResourceService;
        window.angBridge.FavoriteService = FavoriteService;
        window.angBridge.ViewerMessageService = ViewerMessageService;
        window.angBridge.TooltipService = TooltipService;
        window.angBridge.WelcomeMessageService = WelcomeMessageService;
        window.angBridge.WelcomeMessageUtil = WelcomeMessageUtil;
        window.angBridge.LangService = LangService;
        window.angBridge.ContactService = ContactService;
        window.angBridge.InstCssService = InstCssService;
        window.angBridge.LockService = LockService;
        window.angBridge.PermissionService = PermissionService;
        window.angBridge.SpaceService = SpaceService;
        window.angBridge.PendingObjectService = PendingObjectService;
        window.angBridge.EventService = EventService;
        window.angBridge.EventEmailService = EventEmailService;
        window.angBridge.ResourceSpaceAvailService = ResourceSpaceAvailService;
        window.angBridge.ObjectSearchAvailabilityUtil = ObjectSearchAvailabilityUtil;
        window.angBridge.OrganizationService = OrganizationService;
        window.angBridge.PricingService = PricingService;
        window.angBridge.GroupService = GroupService;
        window.angBridge.NameService = NameService;
        window.angBridge.ReservationService = ReservationService;
        window.angBridge.RegistrationService = RegistrationService;
        window.angBridge.BpeService = BpeService;
        window.angBridge.TaskService = TaskService;
        window.angBridge.TaskViewApi = TaskViewApi;
        window.angBridge.AdvancedSearchUtil = AdvancedSearchUtil;
        window.angBridge.LoginService = LoginService;
        window.angBridge.CalendarService = CalendarService;
        window.angBridge.TaskCalendarService = TaskCalendarService;
        window.angBridge.TaskTiersService = TaskTiersService;
        window.angBridge.TaskNormalizeUtil = TaskNormalizeUtil;
        window.angBridge.DashLangService = DashLangService;
        window.angBridge.DashLangMap = DashLangMap;
        window.angBridge.AlertService = AlertService;
        window.angBridge.BoundEventLocationUtil = BoundEventLocationUtil;
        window.angBridge.MergeSearchService = MergeSearchService;
        window.angBridge.SearchCriteriaService = SearchCriteriaService;
        window.angBridge.PublisherService = PublisherService;
        window.angBridge.PasswordResetService = PasswordResetService;
        window.angBridge.LoginExemptRoute = LoginExemptRoute;
        window.angBridge.ModalService = ModalService;
        window.angBridge.EventFormDateOccurrencesModal = EventFormDateOccurrencesModal;
        window.angBridge.EventFormDatePatternPickerModal = EventFormDatePatternPickerModal;
        window.angBridge.EventFormObjectOccurrencesTableModal = EventFormObjectOccurrencesTableModal;
        window.angBridge.OccurrenceEditModal = OccurrenceEditModal;
        window.angBridge.RecommendedBrowsersModalComponent = RecommendedBrowsersModalComponent;
        window.angBridge.ExpressSchedulingModal = ExpressSchedulingModal;
        window.angBridge.ServiceLoader = ServiceLoader;
        window.angBridge.PopoverService = PopoverService;
        window.angBridge.FreshbooksService = FreshbooksService;
        window.angBridge.EventStateChangeService = EventStateChangeService;
        window.angBridge.KeyboardSortableService = KeyboardSortableService;
        window.angBridge.EmbeddingUtil = EmbeddingUtil.getSingleton();
        window.angBridge.OptUtil = OptUtil;
        window.angBridge.Api = Api;
        window.angBridge.AppPathsService = AppPathsService;
        window.angBridge.S25ObjectDetailsService = S25ObjectDetailsService;
        window.angBridge.SearchDropdownApi = SearchDropdownApi;
        window.angBridge.DropdownApi = DropdownApi;
        window.angBridge.RoseUtil = RoseUtil;
        window.angBridge.AddRemoveUtil = AddRemoveUtil;
        window.angBridge.SearchService = SearchService;
        window.angBridge.SearchModelSkipList = SEARCH_MODEL_SKIP_LIST;
        window.angBridge.SearchCriteriaUtil = SearchCriteriaUtil;
        window.angBridge.HierarchyApi = HierarchyApi;
        window.angBridge.EventQuotaService = EventQuotaService;
        window.angBridge.EventFormConflictRepoService = EventFormConflictRepoService;
        window.angBridge.EventFormOccurrenceUtil = EventFormOccurrenceUtil;
        window.angBridge.EventFormStore = EventFormStore;
        window.angBridge.ProfileUtil = ProfileUtil;
        window.angBridge.EventDetailsListService = EventDetailsListService;
        window.angBridge.ItemColorMappingService = ItemColorMappingService;
        window.angBridge.AvailService = AvailService;
        window.angBridge.TaskServiceEdit = TaskEditService;
        window.angBridge.RuleTreeService = RuleTreeService;
        window.angBridge.EventCreationFormService = EventCreationFormService;
        window.angBridge.ReportService = ReportService;
        window.angBridge.Eval25Service = Eval25Service;
        window.angBridge.BoardService = BoardService;
        window.angBridge.BoardConst = BOARD_CONST;
        window.angBridge.OccurrenceProfileUtil = OccurrenceProfileUtil;
        window.angBridge.OccurrenceValidationUtil = OccurrenceValidationUtil;
        window.angBridge.StandardScheduleService = StandardScheduleService;
        window.angBridge.AriaLive = AriaLive;
        AriaLive.init(); // empty live regions must exist before first announce (VoiceOver)
        window.angBridge.EventSummaryService = EventSummaryService;
        window.angBridge.StripeService = StripeService;
        window.angBridge.Sentry = Sentry;
        window.angBridge.TinymceLoader = TinymceLoader;
        window.angBridge.EventFormRuleUtil = EventFormRuleUtil;
        window.angBridge.AuthService = AuthService;
        window.angBridge.S25RuleTreeUtil = S25RuleTreeUtil;
        window.angBridge.TelemetryService = TelemetryService;
        window.angBridge.AiTelemetry = AiTelemetry;
        window.angBridge.ModalMap = ModalMap;
        window.angBridge.DeviceService = DeviceService;
        window.angBridge.CordovaService = CordovaService;
        window.angBridge.PushNotifyService = PushNotifyService;
        window.angBridge.StateService = StateService;
        window.angBridge.NotificationService = NotificationService;
        window.angBridge.StateMap = S25States.typed;
        window.angBridge.ScrollLockService = ScrollLockService;
        window.angBridge.BudgetService = BudgetService;
        window.angBridge.SpreadSheetService = SpreadSheetService;
        window.angBridge.StudentEngagementService = StudentEngagementService;
        window.angBridge.SEEventDetailsStore = SEEventDetailsStore;
        window.angBridge.SeOrgSecurityStore = SeOrgSecurityStore;
        window.angBridge.SeOrgDetailsStore = SeOrgDetailsStore;
        window.angBridge.SeAttendanceStore = SeAttendanceStore;
        window.angBridge.SeEventCheckinStore = SeEventCheckinStore;
        window.angBridge.TaskCompetingUtil = TaskCompetingUtil;
        window.angBridge.NetworkHealthService = NetworkHealthService;
        window.angBridge.PricingStore = PricingStore;
    }
}
